export const getAbsoluteSrc = (relativeSrc) => {
	return new URL(relativeSrc, window.location.origin).href;
};